import { NgModule, Optional, SkipSelf, ErrorHandler } from '@angular/core';
import { throwIfAlreadyLoaded } from './guards/module-import/module-import.guard';
import { PrismModule } from './modules/prism/prism.module';

@NgModule({
  imports: [PrismModule],
  declarations: [],
  providers: [],
  exports: [PrismModule]
})
export class CoreModule {
  constructor(@Optional() @SkipSelf() parentModule: CoreModule) {
    throwIfAlreadyLoaded(parentModule, 'CoreModule');
  }
}
